"use strict";
/* globals module */
/**
 * @module articleInstanceFilesBatchRoute
 * @description Baasic Article Instance Files Batch Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Article Files Batch Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var common_1 = require("../../../common");
var contracts_1 = require("../../../core/contracts");
var ArticleInstanceFilesBatchRoute = /** @class */ (function (_super) {
    tslib_1.__extends(ArticleInstanceFilesBatchRoute, _super);
    function ArticleInstanceFilesBatchRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.unlinkRoute = 'articles/{articleId}/files/batch/unlink';
        _this.updateRoute = 'articles/{articleId}/files/batch';
        _this.linkRoute = 'articles/{articleId}/files/batch/link';
        return _this;
    }
    /**
     * Parses unlink route; this URI template does not expose any additional options.
     * @method
     * @param articleId Article file id of the original article file used to identify article files on which delete action should be performed.
     * @example articleInstanceFilesBatchRoute.unlink(articleId);
     **/
    ArticleInstanceFilesBatchRoute.prototype.unlink = function (articleId) {
        var params = { articleId: articleId };
        return _super.prototype.baseCreate.call(this, this.unlinkRoute, params);
    };
    /**
     * Parses update route; this URI template does not expose any additional options.
     * @method
     * @param articleId Article slug or id which uniquely identifies article whose article file need to be updated.
     * @example articleInstanceFilesStreamsRoute.update(articleId);
     **/
    ArticleInstanceFilesBatchRoute.prototype.update = function (articleId) {
        var params = { articleId: articleId };
        return _super.prototype.baseCreate.call(this, this.updateRoute, params);
    };
    /**
     * Parses update route; this URI template does not expose any additional options.
     * @method
     * @param articleId Article slug or id which uniquely identifies article whose article files need to be linked.
     * @example articleInstanceFilesStreamsRoute.link(articleId);
     **/
    ArticleInstanceFilesBatchRoute.prototype.link = function (articleId) {
        var params = { articleId: articleId };
        return _super.prototype.baseCreate.call(this, this.linkRoute, params);
    };
    var _a;
    ArticleInstanceFilesBatchRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], ArticleInstanceFilesBatchRoute);
    return ArticleInstanceFilesBatchRoute;
}(common_1.BaseRoute));
exports.ArticleInstanceFilesBatchRoute = ArticleInstanceFilesBatchRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
*/
